module.exports = __webpack_public_path__ + "static/media/left-arrow.fc79c01c.svg";